import React from 'react';
import { Calendar, MapPin } from 'lucide-react';

export const PresentationHeader = ({ title, date, location }) => (
  <div className="p-6 border-b border-border-medium">
    <h3 className="heading-4 text-brand-primary mb-2">{title}</h3>
    <div className="flex flex-wrap items-center gap-4 text-text-secondary">
      <div className="flex items-center gap-2">
        <Calendar className="w-4 h-4 text-brand-primary" />
        <span>{date}</span>
      </div>
      <div className="flex items-center gap-2">
        <MapPin className="w-4 h-4 text-brand-primary" />
        <span>{location}</span>
      </div>
    </div>
  </div>
);
